export default __webpack_public_path__ + "static/media/discounts-holiday-image.340c2159.svg";